import React from 'react';
import { Button } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { PatchErrorIcon, PatchMessage, PatchPanel, PatchTitle } from './styles';

const ERROR_TITLE = 'Failed to update the video';
const RETRY_LABEL = 'Try Again';

interface PatchErrorProps {
	reason: string;
	loading: boolean;
	onRetry: () => void;
}

export function PatchError({ reason, loading, onRetry }: Readonly<PatchErrorProps>): JSX.Element {
	const hasReason = !!reason;

	return (
		<PatchPanel>
			<PatchErrorIcon>
				<ExclamationCircleOutlined />
			</PatchErrorIcon>
			<PatchTitle>{I18n.get(ERROR_TITLE)}</PatchTitle>
			{hasReason && <PatchMessage>{reason}</PatchMessage>}
			<Button loading={loading} onClick={onRetry}>
				{I18n.get(RETRY_LABEL)}
			</Button>
		</PatchPanel>
	);
}
